import { Component } from '@theme/component';
import { addFormwinkItems } from '@theme/formwink-cart';

class FormwinkCartRecommendation extends Component {
  busy = false;
  updateAvailability() {
    this.refs.addButton.disabled = this.busy || !this.refs.variant.selectedOptions[0] || this.refs.variant.selectedOptions[0].disabled;
  }
  async add(event) {
    event.preventDefault();
    if (this.busy || this.refs.addButton.disabled) return;
    this.busy = true;
    this.updateAvailability();
    this.refs.status.textContent = this.dataset.addingMessage;
    try {
      await addFormwinkItems(this, [{id: Number(this.refs.variant.value), quantity: 1}], 'cart');
      const checkout = document.querySelector('#cart-drawer [name="checkout"]');
      if (checkout instanceof HTMLElement) checkout.focus();
    } catch (error) {
      this.refs.status.textContent = error.message || this.dataset.errorMessage;
    } finally {
      this.busy = false;
      this.updateAvailability();
    }
  }
}
if (!customElements.get('formwink-cart-recommendation')) customElements.define('formwink-cart-recommendation', FormwinkCartRecommendation);
